export default __webpack_public_path__ + "static/media/dimensions.627ffd5f.png";